import React from 'react'
import LangContext from 'modules/shared/context/langContext'

const title = key => (
  <LangContext.Consumer>{i18n => i18n.gpsUsage[key]}</LangContext.Consumer>
)

// column shows data of the row's declare under the gpsUsage title titleKey, empty when the row has no
// such declare field.
const column = (field, titleKey, data, width) => ({
  title: title(titleKey),
  key: `${field}_${data}`,
  width,
  render: (_, row) => (row[field] || {})[data],
})

// declareColumns are the declare columns that follow the pay status of a metric; field is the row's
// gps_declare, sensor_declare or camera_declare.
export const declareColumns = field => [
  column(field, 'declareStatus', 'state', 130),
  column(field, 'declaredAt', 'declared_at', 140),
  column(field, 'declaredBy', 'declared_by', 160),
  column(field, 'note', 'note', 250),
  column(field, 'reviewedAt', 'reviewed_at', 140),
  column(field, 'reviewedBy', 'reviewed_by', 160),
  column(field, 'reviewNote', 'reject_reason', 250),
]

// cameraColumns are the camera group of a report: its percent, its pay status and its declare columns.
export const cameraColumns = {
  title: <LangContext.Consumer>{i18n => i18n.c.camera}</LangContext.Consumer>,
  children: [
    {
      title: (
        <span>
          <LangContext.Consumer>{i18n => i18n.c.camera}</LangContext.Consumer>
          (%)
        </span>
      ),
      dataIndex: 'percent_camera',
      key: 'percent_camera',
      width: 100,
    },
    {
      title: (
        <LangContext.Consumer>
          {i18n => i18n.i.is_pay_camera}
        </LangContext.Consumer>
      ),
      dataIndex: 'is_pay_camera',
      key: 'is_pay_camera',
      width: 150,
    },
    ...declareColumns('camera_declare'),
  ],
}

// fileColumn shows the link of one file of the row's declare work order, link(row.files) picks it.
const fileColumn = (key, header, link) => ({
  title: header,
  key: `files_${key}`,
  width: 300,
  render: (_, row) =>
    row.files && link(row.files) ? (
      <a href={link(row.files)} target="_blank" rel="noopener noreferrer">
        {link(row.files)}
      </a>
    ) : null,
})

// filesColumn shows the files of the declare work order the row's vehicle is in, the work order's own
// and the vehicle's 3.
export const filesColumn = {
  title: title('files'),
  children: [
    fileColumn('wo', title('woFile'), files => files.wo),
    ...[0, 1, 2].map(i =>
      fileColumn(
        `vehicle_${i}`,
        <span>
          {title('vehicleFileColumn')} {i + 1}
        </span>,
        files => files.vehicle[i],
      ),
    ),
  ],
}
